import { useNavigate } from 'react-router';
import { SigninScreen } from './SigninScreen';

/**
 * /auth/signup is the sign-in screen with the signup chat already open: the same
 * page, so a link into signup lands where "Create an account" would have taken
 * the visitor, with the same panel and the same way back.
 *
 * Closing the chat returns to /auth/signin, so the address bar says what the page
 * is showing. Replaced rather than pushed: Back from the sign-in form should leave
 * the auth screens, not reopen a signup chat the visitor just dismissed.
 */
export const SignupScreen = () => {
  const navigate = useNavigate();

  return <SigninScreen startInSignup onClosed={() => navigate('/auth/signin', { replace: true })} />;
};
